module.exports = __webpack_public_path__ + "e0516e5be772a548898b7e0b601a4d09.svg";